import * as THREE from "three";
import { BearManager } from "@/argo_ar/argo_webar_lib/BearAssetManager";
import { Marker } from "@/models/Marker";

let instance: SceneManager = null;

/**
 * Inspired from https://github.com/bear2b/argo_webar_library_ts/blob/dev/src/scene.ts
 */
export class SceneManager {
    public static sId = 1;
    private bearAssetManager: BearManager;
    private deviceId: string;
    private pageId: number;
    public scene: THREE.Scene = new THREE.Scene();

    private loaderTexture = new THREE.TextureLoader().load("/img/loader.png");
    private erroredTexture = new THREE.TextureLoader().load("/img/errored.png");

    private mixers: any[] = [];

    public initialized = false;

    public init(pageId: number, deviceId = "") {
        this.initialized = false;
        this.pageId = pageId;
        this.deviceId = deviceId;

        this.mixers = [];
        this.scene = new THREE.Scene();
        this.scene.name = "markerBase";

        this.bearAssetManager = new BearManager(this.scene);
        this.initialized = true;
    }

    public resetScene() {
        this.scene.clear();
    }

    public async loadMarkerAssets(marker: Marker): Promise<void> {
        return new Promise((resolve, reject) => {
            this.bearAssetManager
                .fnLoadAssets(
                    marker.assets,
                    marker,
                    this.loaderTexture,
                    SceneManager.sId,
                    (asset: any) => {
                        if (asset.mixer) {
                            this.mixers.push(asset.mixer);
                        }
                        asset.visible = asset.originalAsset.name.indexOf("hide") === -1;
                        this.scene.add(asset);
                        this.scene.remove(asset.originalAsset.placeHolder);
                    },
                    (erroredAsset: any) => {
                        console.log("error loading" + erroredAsset);
                    }
                )
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });
    }
}

const getSceneManager = () => {
    if (!instance) {
        instance = new SceneManager();
    }

    return instance;
};

export default getSceneManager;
